import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { createUniqueCustomProperties } from '../../../utils/createUniqueCustomProperty.es.js';
import { Vars as Vars$1 } from './Vars.es.js';

const Vars = createUniqueCustomProperties("TableTd", ["frozenCellZindex"]);
const Styles = labelStyles("TableTd", {
  root: css`
    display: table-cell;
    vertical-align: middle;
    // For Safari
    text-align: initial;
    min-height: var(--zds-size-48);

    // tbody cells should always render lowest
    tbody &,
    tbody & {
      ${Vars.frozenCellZindex}: 1;
    }

    // thead cells should always render above tbody cells
    thead &,
    thead & {
      ${Vars.frozenCellZindex}: 2;
    }

    // thead cells that freeze in both directions should always
    // render at the very top
    thead &[data-freeze='row col'],
    thead &[data-freeze='row col'] {
      ${Vars.frozenCellZindex}: 3;
    }

    &[data-freeze~='col'] {
      position: sticky;
      left: 0;
      z-index: var(${Vars.frozenCellZindex}, 1);

      // Render the shadow on a frozen column
      &[data-shadowed~='col'] {
        &::before {
          pointer-events: none;
          content: '';
          display: block;
          position: absolute;
          width: 5px;
          top: 0;
          left: 100%;
          bottom: 0;
          opacity: var(${Vars$1.frozenCellHorzShadowOpacity}, 0);
          transition: all 200ms ease-in-out;
          background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0)
          );
        }
      }
    }

    &[data-freeze~='row'] {
      position: sticky;
      top: 0;
      z-index: var(${Vars.frozenCellZindex}, 1);

      // Render the shadow on a frozen row
      &[data-shadowed~='row'] {
        &::after {
          pointer-events: none;
          content: '';
          display: block;
          position: absolute;
          height: 5px;
          top: 100%;
          left: 0;
          width: 100%;
          opacity: var(${Vars$1.frozenCellVertShadowOpacity}, 0);
          transition: all 200ms ease-in-out;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0)
          );
        }
      }
    }
  `
});
const TableTd = (props) => {
  return jsx("td", { css: [Styles.root, props.className], "data-freeze": props.freeze, "data-shadowed": props.shadowed, "data-zds": true, headers: props.headers, role: "cell" }, props.children);
};

export { Styles, TableTd };
//# sourceMappingURL=TableTd.es.js.map
